module.exports = __webpack_public_path__ + "img/10602501.9c43c4d0.png";